// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerClickableStyles } from "@steiner/App/Components/Header/HeaderClickable";
import { HEADER_BREAKPOINT } from "@steiner/Overrides/Pages/Header";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

const sharedCompactClickableStyles = css`
    min-width: initial;
    flex-direction: row;
    gap: 8px;
`;

const sharedCompactIconStyles = css`
    &,
    & > svg {
        width: 15px;
        height: 15px;
    }
`;

const sharedCompactTextStyles = css`
    font-size: 14px;
    line-height: 18px;
    text-align: left;
`;

headerClickableStyles.clickable = {
    css: css`
        display: flex;
        flex-direction: column;
        min-width: 80px;

        ${({ isCompactHeader }: any) => isCompactHeader && sharedCompactClickableStyles}

        ${xScreen("lte", HEADER_BREAKPOINT)} {
            ${sharedCompactClickableStyles}
        }
    `,
};

headerClickableStyles.iconWrapper = {
    css: css`
        ${xScreen("lte", "md")} {
            display: flex;
        }
    `,
};

headerClickableStyles.icon = {
    size: 26,
    color: "common.white",
    css: css`
        ${({ isCompactHeader }: any) => isCompactHeader && sharedCompactIconStyles}

        ${xScreen("lte", HEADER_BREAKPOINT)} {
            ${sharedCompactIconStyles}
        }
    `,
};

headerClickableStyles.title = {
    size: 12,
    weight: "bold",
    color: "common.white",
    css: css`
        line-height: 15px;
        text-align: center;

        ${({ isCompactHeader }: any) => isCompactHeader && sharedCompactTextStyles}

        ${xScreen("lte", HEADER_BREAKPOINT)} {
            ${sharedCompactTextStyles}
        }
    `,
};

headerClickableStyles.openColor = "secondary";
